var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserProfile',{attrs:{"user-id":_vm.userId},on:{"after-follow-change":_vm.afterFollowChange}}),_c('NavTabs'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }